import angular from 'angular';
import toastr from 'angular-toastr';
import CommonComponents from './Components';
import Services from './services'

let commonModule = angular.module('app.common', [
  CommonComponents.name,
  Services.name, 
  toastr,
]);

export default commonModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/common.js
 **/